import {
  IAppUser,
  ICatalogContainerInsectGrowthStageView,
  ICatalogContainerSubstrateView,
  ICatalogInsect,
  ICatalogInsectGrowthStage,
  ICatalogInsectVariant,
  ICatalogSubstrate,
  ICatalogWorkflowNotification,
  IContainer,
  IDictionaryEntry,
  IGrowthStage,
  IInsectGrowthStage,
  ISurveyQuestion
} from '../services/insecta/insecta.models';
import { collectionComparator } from './functions';

export const appUserSort = collectionComparator<IAppUser>(
  (x) => x.isActive,
  (x) => x.displayName,
  (x) => x.email
);

export const containerSort = collectionComparator<IContainer>(
  (x) => x.isActive,
  (x) => x.name
);

export const growthStageAdminSort = collectionComparator<IGrowthStage>(
  (x) => x.sortOrder ?? 999,
  (x) => x.name
);

export const growthStageSort = collectionComparator<IGrowthStage>(
  (x) => x.isActive,
  (x) => x.sortOrder ?? 999,
  (x) => x.name
);

export const catalogContainerInsectSort = collectionComparator<ICatalogContainerInsectGrowthStageView>(
  (x) => x.isActive,
  (x) => x.scientificName,
  (x) => x.growthStageSortOrder ?? 999
);

export const catalogContainerSubstrateSort = collectionComparator<ICatalogContainerSubstrateView>(
  (x) => x.isActive,
  (x) => x.substrateName
);

export const catalogInsectSort = collectionComparator<ICatalogInsect>(
  (x) => x.isActive,
  (x) => x.insect.scientificName
);

export const catalogInsectGrowthStageSort = collectionComparator<ICatalogInsectGrowthStage>(
  (x) => x.isActive,
  (x) => x.insectGrowthStage.growthStage.sortOrder ?? 999,
  (x) => x.insectGrowthStage.growthStage.name
);

export const catalogInsectVariantSort = collectionComparator<ICatalogInsectVariant>(
  (x) => x.isActive,
  (x) => x.insectVariant.variantType.name
);

export const catalogSubstrateSort = collectionComparator<ICatalogSubstrate>(
  (x) => x.isActive,
  (x) => x.substrate.name
);

export const catalogWorkflowNotitificationSort = collectionComparator<ICatalogWorkflowNotification>(
  (x) => x.isActive,
  (x) => x.workflowStatusCode.orderEntityType,
  (x) => x.workflowStatusCode.name
);

export const dictionaryEntrySort = collectionComparator<IDictionaryEntry>((x) => x.text);

export const insectGrowthStageSort = collectionComparator<IInsectGrowthStage>(
  (x) => x.growthStage.isActive,
  (x) => x.growthStage.sortOrder ?? 999,
  (x) => x.growthStage.name
);

export const questionSort = collectionComparator<ISurveyQuestion>((x) => `${x.order}`);
